<template>
  <div class="style-selector"  :class="{sel: isSelected}" v-on:click="toggleShowDrop" ref="styledropper">
    <div class="placeholder" >{{ title }}</div>
    <transition name="fade">
      <div class="drop-items" v-show="showDrop" :class="colClass">
        <div v-on:click.stop="selectItem(gallery)"
          class="search-item" v-for="gallery in items" :key="gallery.gallery_id" :class="{sel: gallery.gallery_id === selectedItem}">
          {{ gallery.name }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: String,
    kind: String,
    animation: Boolean,
    selectedId: String
  },
  computed: {
    title: function () {
      let n = this.findName(this.selectedItem)
      if(n) return n;
      return this.placeholder
    },
    isSelected: function () {
      return this.findName(this.selectedItem)
    },
    colClass: function () {
      let len = this.items.length
      if(len > 18) return ''
      if(len > 10) return 'col2'
      return 'col1'
    }
  },
  data () {
    return {
      selectedItem: '0',
      items: [],
      showDrop: false
    }
  },
  created () {
    this.selectedItem = this.selectedId
    this.init()
  },
  mounted () {
    document.body.addEventListener('click', (e) => {
      if(this.showDrop) {
        if(!this.$refs.styledropper.contains(e.target)){
          this.showDrop = false
        }
      }
    })
  },
  methods: {
    init: async function () {
      let galleries = await this.$store.dispatch('fetchGalleries')
      let gals = galleries.filter(el => (el.animation === this.animation))
      gals = gals.sort((el, el2) => el.name.localeCompare(el2.name))
      if(this.kind){
        this.items = gals.filter(el => el.category === this.kind)
      }
      else {
        this.items = gals
      }
    },
    findName: function (galid) {
      let g = this.items.find(el => el.gallery_id === galid)
      if(g) return g.name
      return ''
    },
    selectItem(gal) {
      this.selectedItem = gal.selectedId
      this.showDrop = false
      this.$emit('select', this.selectedItem)
      this.$ixr.push(gal.url)
    },
    toggleShowDrop () {
      this.showDrop = !this.showDrop
    }
  },
  watch: {
    kind () {
      this.init()
    },
    selectedId () {
      this.selectedItem = this.selectedId
    }
  }

}
</script>

<style>
.style-selector{
  position:relative;
  border: 1px solid #a7aba1;
  border-radius: 6px;
  cursor:pointer;
  display: inline-block;
  padding:9px 32px 9px 12px;
  margin-bottom:0;
  color:#a7aba1;
  background-image:url('../../assets/img/arrow-right-white.svg');
  background-position:center right 3px;
  background-size:24px 60%;
  min-width:218px;
}

.style-selector.sel, .style-selector:hover {
  background-color:#ce0e2d;
  border-color:#ce0e2d;
  color:#fff;
}
.drop-items{
  position:absolute;
  top:100%;
  left:0;
  background-color:#fff;
  padding:10px;
  color:black;
  box-sizing:border-box;
  width:300%;
  z-index:100;
  columns: 3;
  line-height:26px;
}

.drop-items.col2{
  columns: 2;
  width:200%;
}

.drop-items.col1{
  columns: 1;
  width:100%;
}


</style>
